import React from 'react';
import useScrollFadeIn from '../hooks/useScrollFadeIn';
import { trackEvent, appendUTMsToUrl } from '../services/analytics';
import LeadCaptureForm from './LeadCaptureForm';

const APP_URL = 'https://app.botibonga.com';

function handleLoginClick(e) {
  trackEvent('cta_click', { location: 'final_cta', label: 'Log In' });
  const target = appendUTMsToUrl(APP_URL);
  if (target !== APP_URL) {
    e.currentTarget.href = target;
  }
}

const gradientText = {
  background: 'linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export default function CTA() {
  const { ref, isVisible } = useScrollFadeIn();

  return (
    <section id="cta" className="py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto text-center transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* CTA card */}
        <div
          className="rounded-3xl p-10 sm:p-14 relative overflow-hidden"
          style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border-card)',
            boxShadow: 'var(--shadow-card-lg)',
            backdropFilter: 'blur(var(--glass-blur))',
            WebkitBackdropFilter: 'blur(var(--glass-blur))',
          }}
        >
          {/* Decorative accent line */}
          <div
            className="absolute top-0 left-0 w-full h-px"
            style={{
              background: 'linear-gradient(90deg, transparent 0%, #6366f1 50%, transparent 100%)',
              opacity: 0.3,
            }}
          />

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text-heading)' }}>
            Ready to Transform Your{' '}
            <span style={gradientText}>WhatsApp Customer Service</span>?
          </h2>
          <p className="text-base sm:text-lg mb-8 max-w-xl mx-auto" style={{ color: 'var(--text-body)' }}>
            Join businesses using Botibonga Studio to reply faster, capture more leads, and never miss
            a customer message.
          </p>

          {/* Lead capture form */}
          <LeadCaptureForm source="final_cta" ctaLabel="Get Started Free" showMessage />

          <p className="mt-5 text-xs" style={{ color: 'var(--text-muted)' }}>
            Already have an account?{' '}
            <a
              href={APP_URL}
              onClick={handleLoginClick}
              className="underline font-medium"
              style={{ color: 'var(--text-accent)' }}
            >
              Log in
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
